export const parseAlignmentToJustifyContent = (alignment: string) => {
  switch (alignment) {
    case 'left':
      return 'flex-start';
    case 'center':
      return 'center';
    case 'right':
      return 'flex-end';
    default:
      return alignment;
  }
};

export const parseJustifyContentToAlignment = (justifyContent: string) => {
  switch (justifyContent) {
    case 'flex-start':
      return 'left';
    case 'center':
      return 'center';
    case 'flex-end':
      return 'right';
    default:
      return justifyContent;
  }
};
